<template>
  <div class="contact">
    <div class="MainOne">
      <img src="../assets/image/联系我们.png" alt="" style="height: 500px" />
    </div>
    <div class="MainTwo">
      <div style="width: 100%; margin: 0 auto">
        <div class="right_letter">
          倾听您的需求，解决您的问题，我们时刻在线!
        </div>
      </div>
      <h2>联系方式</h2>
      <h3>Contact information</h3>

      <div class="information" id="sectionA">
        <table class="adaptive-table">
          <tr>
            <td>江苏君成智慧洁净科技有限公司</td>
          </tr>
          <tr>
            <td style="width: 50%">联系人: 吴经理</td>
            <td style="width: 50%">手机号: 18100681818</td>
          </tr>
          <tr>
            <td style="width: 50%">网址: www.jcgyzn.com</td>
            <td style="width: 50%">电话: 0512-65165589</td>
          </tr>
          <tr>
            <td style="width: 50%">地址: 苏州市吴江区云创路229号2层</td>
            <td style="width: 50%">售后服务热线: 18912720358</td>
          </tr>
        </table>
      </div>
      <div style="width: 100%; margin: 0 auto">
        <div class="right_letter">欢迎留言!</div>
      </div>
      <h2>在线留言</h2>
      <h3>Online message</h3>

      <div class="box" id="sectionB">
        <div class="message" style="font-size: 55px">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="您的姓名" prop="name">
              <el-input
                style="width: 80%"
                v-model="ruleForm.name"
                placeholder="请输入您的姓名"
              ></el-input>
            </el-form-item>

            <el-form-item label="电话号码" prop="phone">
              <el-input
                style="width: 80%"
                v-model="ruleForm.phone"
                placeholder="请输入您的电话号码"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="电子邮箱" prop="email">
              <el-input
                style="width: 80%"
                v-model="ruleForm.email"
                placeholder="请输入您的电子邮箱"
              >
              </el-input>
            </el-form-item>

            <el-form-item label="留言内容" prop="content">
              <el-input
                type="textarea"
                style="width: 80%"
                v-model="ruleForm.content"
                class="input-with-select"
              ></el-input>
            </el-form-item>
            <el-form-item style="margin-right: -64px">
              <el-button
                type="primary"
                @click="submitForm('ruleForm')"
                :plain="true"
                >提交留言</el-button
              >
              <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLiuyanList } from "@/api";
export default {
  name: "ContactUs",
  mounted() {
    this.scrollToPosition();
  },
  watch: {
    "$route.query.scrollTo"(newVal) {
      this.scrollToPosition(newVal);
    },
  },
  data() {
    return {
      ruleForm: {
        name: "",
        phone: "",
        delivery: false,
        type: [],
        resource: "",
        content: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入您的姓名！", trigger: "blur" },
          { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入您的电话号码", trigger: "blur" },
          {
            min: 11,
            max: 11,
            message: "请输入正确的11位电话号码!",
            trigger: "blur",
          },
        ],
        content: [
          { required: true, message: "请输入留言内容", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    scrollToPosition(section = null) {
      let element = null;
      if (section) {
        element = document.querySelector(`#${section}`);
      } else {
        // 默认滚动到页面顶部
        element = document.body;
      }
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    submitForm(ruleForm) {
      getLiuyanList(this.ruleForm)
        .then((res) => {
          if (res.code === "200") {
            this.$message({
              message:
                "感谢您的留言，我们已经收到并会尽快处理。再次感谢您的参与和支持！",
              type: "success",
            });
            this.$refs[ruleForm].resetFields();
          } else {
            this.$message.error("请输入正确的信息以及留言！");
            console.log("error submit!!");
            return false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    resetForm(ruleForm) {
      this.$refs[ruleForm].resetFields();
    },
  },
};
</script>
<style lang="scss" scoped>
@media (max-width: 880px) {
  .MainOne {
    display: none;
  }
}
@media (max-width: 470px) {
  .input-with-select {
    width: 100%;
  }
}
.adaptive-table {
  width: 76%; /* 使表格宽度自适应容器 */
  border-collapse: collapse; /* 移除单元格之间的空白 */
}

.adaptive-table td {
  border: 1px solid #ddd; /* 添加边框 */
  padding: 8px; /* 添加内边距 */
  box-sizing: border-box; /* 确保内边距和边框不会增加单元格的总宽度 */
  border: none;
}
.MainOne {
  height: 500px;
}
el-form-item {
  list-style: 56px;
}
.demo-ruleForm {
  font-size: 53px;
  width: 400px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.right_letter {
  border-bottom: 2px solid #ccccccf0;
  text-align: right;
  margin-top: 42px;
}
.contact {
  width: 100%;
  height: auto;
  margin: 0 auto;
  background-color: rgb(243, 245, 245);
}
.MainTwo {
  height: auto;
  margin: 0 auto;
  margin-top: 20px;
}
.contact hr {
  color: rgb(136, 126, 126);
}
h2 {
  text-align: right;
  text-align: left;
  color: blue;
  margin-top: 10px;
}
.contact h3 {
  text-align: left;
  color: grey;
  margin-bottom: 30px;
}
.information {
  width: 100%;
  height: 500px;
  background-color: rgb(230, 233, 233);
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.information table td {
  height: 80px;
  font-size: 1.5vw;
  margin-left: 50px;
  text-align: left;
}
.box {
  width: 100%;
  height: 580px;
  margin: auto;
  margin-top: 80px;
  margin-bottom: 50px;
}

.message {
  width: 100%;
  height: 580px;
  background-color: rgb(230, 233, 233);
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -50px;
}
</style>
